export default "__VITE_ASSET__WT2KSbwd__";